<template>
  <div class="pt-login">
    <div class="login__container">
      <div class="login__container--left">
        <img src="@/assets/images/login_logo.png" alt="">
        <h2>生命银行管理中心</h2>
        <!-- <h3>尊贵服务爱的托付</h3> -->
      </div>
       <div class="login__container__form">
        <h3>登&nbsp;&nbsp;录</h3>
        <pt-form-item :lineHeight="lineHeight">
          <el-input v-model="loginForm.username" placeholder="用户名/手机号/用户ID" name="username" data-vv-as="用户名/手机号/用户ID" v-validate="'required'"></el-input>
        </pt-form-item>
        <pt-form-item :lineHeight="lineHeight">
          <el-input v-model="loginForm.password" placeholder="密码" type="password" name="password" data-vv-as="密码" v-validate="'required'"></el-input>
        </pt-form-item>
        <!-- <el-form-item>
          <el-checkbox v-model="loginForm.rememberMe">记住账号</el-checkbox>
        </el-form-item> -->
        <!-- <p class="forget">忘记密码</p> -->
        <pt-form-item>
          <el-button type="primary" @click="handleLogin()" style="width:100%">登&nbsp;&nbsp;录</el-button>
        </pt-form-item>
      </div>
    </div>

  </div>
</template>

<script>
import { validate } from 'utils/validate'
// 组件class前缀
const prefixCls = 'pt-login'
export default {
  name: 'pt-login',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    loginForm: {
      type: Object,
      required: true
    },
    onLogin: {
      type: Function
    }
  },
  data () {
    return {
      lineHeight: '90'
    }
  },
  methods: {
    formValidate () {
      return validate(this, this.loginForm)
    },
    handleLogin () {
      this.onLogin && this.onLogin()
    }
  }

}
</script>

<style lang="less">
@import '~less/var.less';
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-login {
  position: fixed;
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/images/login_back.png);//此为图片地址
  background-size: cover;
  .login__container{
    width:70%;
    min-width: 900px;
    margin:10% auto 0;
    min-height:500px;
  }
  .login__container--left{
    float: left;
    color: #fff;
    img{
      margin-bottom: 80px;
    }
    h2{
      font-size: 56px;
      font-weight: normal;
    }
    h3{
      font-size: 50px;
      font-weight: lighter;
    }
  }
  .login__container__form{
    float: right;
    width:360px;
    padding:30px 30px 50px;
    background: #fff;
    border-radius: 10px;
    h3{
      text-align: center;
      font-size: 40px;
      font-weight: 200;
      margin:10px 0 30px;
    }
  }
  .el-input__inner{
    height: 52px;
  }
  .forget{
    text-align: right;
    color:@mainColor;
  }
  .el-button{
    padding:14px 0;
    font-size: 22px;
  }
}
</style>
